import { Image } from 'lucide-react';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

interface ProductOfferImageProps {
  image: string | null;
  name: string;
}

export const ProductOfferImage = ({ image, name }: ProductOfferImageProps) => {
  if (!image) {
    return (
      <div className="inline-flex items-center justify-center w-16 h-16 border rounded-md border-border">
        <Image className="w-6 h-6" />
      </div>
    );
  }

  return (
    <button
      type="button"
      className="cursor-zoom-in"
      onClick={() => Fancybox.show([{ src: image, caption: name }])}
    >
      <img
        src={image}
        alt={name}
        className="object-cover object-center w-16 h-16 rounded-md"
      />
    </button>
  );
};
